import { App, Button, Card, Empty, Form, InputNumber, Select, Space, Tag } from 'antd'
import { ExperimentOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'

import useAuthStore from '@/stores/AuthStore'
import { DEI_Lgc_Mapped } from '@/views/Conversations/Online/Input/AutoSendWAForEmail'
import { openPopup } from '@/hooks/useEmail'
import { getTemplateListAction } from '@/actions/HtTemplateActions'

// 管理员白名单
export const TEMPLATE_ADMIN_USERIDS = ['404', '383', '227', '155', '746']

// 小组选项
const DEI_OPTIONS = Object.values(DEI_Lgc_Mapped)
  .filter((d) => d.DEI_DepartmentName && !d.DEI_DepartmentName.includes('待删除'))
  .map((d) => ({ label: d.DEI_DepartmentName, value: d.DEI_SN }))

// 语言选项（取自 DEI_Lgc_Mapped 中非空 DEI_LGC，去重）
const LGC_OPTIONS = Array.from(
  new Map(Object.values(DEI_Lgc_Mapped).filter((d) => d.DEI_LGC).map((d) => [d.DEI_LGC, d.lgc_n])),
).map(([value, label]) => ({ label, value }))

// 测试预览默认订单号
const TEST_COLI_SN = 1308942

// 测试案例：点击自动填充表单
const TEST_CASES = [
  { label: '报价信·1308942', values: { template: 'CH_报价信', dei_sn: 1, lgc: 1, coli_sn: 1308942 } },
  { label: '报价信·18108', values: { template: 'CH_报价信', dei_sn: 1, lgc: 1, coli_sn: 18108 } },
  { label: '报价信·1308941', values: { template: 'CH_报价信', dei_sn: 1, lgc: 1, coli_sn: 1308941 } },
  { label: '确认信·1331099', values: { template: 'CH_确认信', dei_sn: 1, lgc: 1, coli_sn: 1331099 } },
  { label: '确认信·1331091', values: { template: 'CH_确认信', dei_sn: 1, lgc: 1, coli_sn: 1331091 } },
]

function HtTemplateManager() {
  const { message } = App.useApp()
  const [form] = Form.useForm()

  const [loginUser] = useAuthStore((state) => [state.loginUser])
  const isAdmin = TEMPLATE_ADMIN_USERIDS.includes(String(loginUser.userId))

  const [templates, setTemplates] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchTemplates = async () => {
    setLoading(true)
    try {
      const list = await getTemplateListAction()
      setTemplates(list)
    } catch (e) {
      setTemplates([])
      message.error(e?.message || '获取模板列表失败')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTemplates()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 模板选项：文件名为 {事业部code}_{类型}.html
  const TEMPLATE_OPTIONS = templates.map((t) => ({ label: `${t.group}_${t.type}`, value: `${t.group}_${t.type}` }))

  const handleTest = async () => {
    const values = await form.validateFields()
    const [group, type] = values.template.split('_')
    openPopup(
      `/ht_templates/preview/${values.dei_sn}/${encodeURIComponent(type)}?coli_sn=${values.coli_sn}&lgc=${values.lgc}&name=${encodeURIComponent(group)}`,
      `ht_tpl_preview_${group}_${type}`,
      { width: 1500, height: 900, left: 80, top: 60 },
    )
  }

  if (!isAdmin) {
    return (
      <div style={{ padding: 24 }}>
        <Empty description='无权限访问模板管理' />
      </div>
    )
  }

  return (
    <div style={{ padding: 12 }}>
      <Card
        size='small'
        title={
          <Space>
            <span style={{ fontSize: 16, fontWeight: 600 }}>模板测试</span>
            <Tag color='green'>管理员</Tag>
          </Space>
        }
      >
        <Form form={form} layout='inline' initialValues={{ dei_sn: 1, lgc: 1, coli_sn: TEST_COLI_SN }} onFinish={handleTest} style={{ rowGap: 12 }}>
          <Form.Item label='模板' name='template' rules={[{ required: true, message: '请选择模板' }]}>
            <Select showSearch optionFilterProp='label' placeholder='选择模板' style={{ width: 240 }} loading={loading} options={TEMPLATE_OPTIONS} />
          </Form.Item>
          <Form.Item label='小组' name='dei_sn' rules={[{ required: true, message: '请选择小组' }]}>
            <Select showSearch optionFilterProp='label' options={DEI_OPTIONS} placeholder='选择小组' style={{ width: 200 }} />
          </Form.Item>
          <Form.Item label='语言' name='lgc' rules={[{ required: true, message: '请选择语言' }]}>
            <Select options={LGC_OPTIONS} style={{ width: 180 }} />
          </Form.Item>
          <Form.Item label='订单coli_sn' name='coli_sn' rules={[{ required: true, message: '请输入订单SN' }]}>
            <InputNumber style={{ width: 160 }} />
          </Form.Item>
          <Form.Item>
            <Button type='primary' icon={<ExperimentOutlined />} htmlType='submit'>
              测试
            </Button>
          </Form.Item>
        </Form>
        <div style={{ marginTop: 24, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={{ fontSize: 12, color: '#888' }}>测试案例：</span>
          {TEST_CASES.map((c) => (
            <Button key={c.label} size='small' onClick={() => form.setFieldsValue(c.values)}>{c.label}</Button>
          ))}
        </div>
      </Card>
    </div>
  )
}

export default HtTemplateManager
